import { doPrivatePostRequest } from "./requests";

export const getActivity = (_doc_id, _token) => {
  const path = `/activity-logs/get`;
  const params = {
    st: "DOC-ID",
    sk: _doc_id,
  };

  return doPrivatePostRequest(params, path, _token);
};

export const getRecentActivity = (_user_id, _date_range, _token) => {
  const path = `/activity-logs/get`;
  
  const params = {
    st: "BY-USER-ID-DR",
    sk: _user_id,
    sv: _date_range,
  };
  
  return doPrivatePostRequest(params, path, _token);
};

export const getAdminRecentActivity = (_date_range, _token) => {
  const path = `/activity-logs/get`;
  
  const params = {
    st: "ALL-DR",
    sk: _date_range,
    // sv: _date_range,
  };
  
  return doPrivatePostRequest(params, path, _token);
};

